import { Component } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-terms-of-use-modal",
  standalone: true,
  templateUrl: "./terms-of-use-modal.component.html",
  styleUrls: ["./terms-of-use-modal.component.scss"],
  imports: [TranslateModule],
})
export class TermsOfUseModalComponent {
  constructor(private readonly matDialog: MatDialog) {}

  protected close() {
    this.matDialog.closeAll();
  }
}
